module.exports = __webpack_public_path__ + "img/ProfilePicture.6d86c565.png";